function NoIndexNoFollow() {
  return (
    <>
      <meta name="robots" content="noindex" />
      <meta name="robots" content="nofollow" />
    </>
  )
}
export default NoIndexNoFollow
